// extracted by mini-css-extract-plugin
export default {"app":"TeachModal_app__qK9ye","pic":"TeachModal_pic__BialO","checkDiv":"TeachModal_checkDiv__Q4DXR"};